export default __webpack_public_path__ + "static/media/20.02d0fa30.jpg";